import { ProductInfoProduct } from '../../../types'

export const getDimensions = (
  variantDimensions?: ProductInfoProduct['variants'][number]['dimensions'],
) => variantDimensions?.description ?? ''
